import * as Sentry from "@sentry/vue";

export const getDefaultSentryConfig = ({ app, dsn, router, release, enabled, environment }) => ({
  app,
  dsn,
  enabled,
  integrations: [
    Sentry.browserProfilingIntegration(),
    Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
    Sentry.vueIntegration({ tracingOptions: { trackComponents: true } }),
    Sentry.browserTracingIntegration({ router }),
  ],
  tracesSampleRate: 0.3,
  profilesSampleRate: 0.01,
  replaysSessionSampleRate: 0.01,
  replaysOnErrorSampleRate: 1,
  environment,
  release,
});
